import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import {useCheckPermission} from "../hooks/permissionHooks";
import {selectUsername} from "../redux/authSlice";
import type {PermissionRule} from "../util/permissions";

interface Props {
    permissionRule?: PermissionRule;
    missingPermissions?: boolean;
    children: React.ReactNode;
}

function MissingPermissionIndicator({permissionRule, missingPermissions, children}: Props): React.ReactNode {
    const {t} = useTranslation();

    const username = useSelector(selectUsername);
    const permitted = useCheckPermission(permissionRule);

    if (permissionRule && permitted) {
        return children; // Don't show permission error, if permission rule was provided AND is granted
    }
    if (missingPermissions === false) {
        return children; // Don't show permission error, if missingPermissions flag was provided AND flag is false
    }

    return (
        <div className="grow flex flex-col justify-center items-center">
            <div className="p-inline-message p-component p-inline-message-warn block">
                <div className="m-4 mb-8 text-2xl">
                    <span className="pi pi-lock text-2xl mr-4"></span>
                    {t("general.missingPermissionTitle")}
                </div>
                <p className="m-4">
                    {t("general.missingPermission1")}
                    <strong>{username}</strong>
                    {t("general.missingPermission2")}
                </p>
                <p className="m-4 mt-0">
                    {t("general.missingPermissionContact")}
                    <a
                        href="https://www.value-marktdaten.de/contact"
                        target="_blank"
                        rel="noreferrer"
                        style={{color: "inherit"}}
                        className="p-button-label ml-2"
                    >
                        {t("general.contact")}
                    </a>
                </p>
            </div>
        </div>
    );
}

export default MissingPermissionIndicator;
